// src/components/ProtectedRoute.js
import React, { useContext } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useLanguage } from '../hooks/useLanguage';
import { UserContext } from '../context/UserContext';

const ProtectedRoute = () => {
  const { user, hasLoadedFromLocalStorage } = useContext(UserContext); // Get user object and the new flag
  const lang = useLanguage();

  // If the UserContext hasn't finished loading from localStorage yet,
  // return null to prevent premature redirection.
  if (!hasLoadedFromLocalStorage) {
    return null; // Or a loading spinner if you prefer
  }

  // Once loaded, proceed with the authentication check.
  return user.isLoggedIn ? <Outlet /> : <Navigate to={`/${lang}/login`} />;
};

export default ProtectedRoute;
